import { ChatBubbleOvalLeftEllipsisIcon, UserGroupIcon } from "@heroicons/react/24/outline";
import React from "react";
import SlideOver from "src/components/Shared/SlideOver";
import Tabs from "src/components/Shared/Tabs/Tabs";
import BannerDetails from "./BannerDetails";
import NtificationCancelleationList from "./NotificationLogs/NtificationCancelleationList";
import { useMemo } from "react";

const NotificationAddSlider = ({ workspaceId, isOpen, formData, footerComponent, setFormData, handleClose, clients, extraProps }) => {
  const tabs = useMemo(() => {
    const notificationTabs = [
      {
        name: "Banner Details",
        icon: ChatBubbleOvalLeftEllipsisIcon,
        component: (
          <BannerDetails
            formData={formData}
            setFormData={setFormData}
            clients={clients}
          />
        ),
      },
    ];

    if (formData?._id) {
      notificationTabs.push({
        name: "Notification Logs",
        icon: UserGroupIcon,
        component: (
          <NtificationCancelleationList
            workspaceId={workspaceId}
            notification={formData}
            setFormData={setFormData}
            extraProps={extraProps}
          />
        ),
      });
    }

    return notificationTabs;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData?._id, workspaceId, extraProps, formData, setFormData]);

  return (
    <SlideOver
      size="3xl"
      isOpen={isOpen}
      closeable={false}
      handleClose={handleClose}
      title={formData?._id ? "Edit Banner" : "Add Banner"}
      bodyClassName="!p-6"
      description="View, style your banner and style accordingly, with a preview."
      topActionButton={footerComponent}>
      <Tabs
        tabs={tabs}
        queryParamName="notificationTabs"
      />
    </SlideOver>
  );
};

export default NotificationAddSlider;
